import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-16 md:py-24 px-4" style={{
    backgroundColor: '#ffffff'
  }} data-id="element-15">
      <div className="max-w-4xl mx-auto" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} data-id="element-17">
          <span className="text-sm font-bold tracking-[0.2em] uppercase mb-3 inline-block" style={{
          color: '#e76f51'
        }} data-id="element-18">
            🔥 TU TRANSFORMACIÓN
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mb-8" style={{
          color: '#1A1614'
        }} data-id="element-19">
            Pasas de improvisar a ejecutar con método
          </h2>

          {/* Before → After rows */}
          <div className="space-y-3 mb-10" data-id="element-20">
            {[{
            before: 'Improvisar',
            after: 'Diseñar producto estratégico'
          }, {
            before: 'Competir por precio',
            after: 'Diferenciarte por percepción'
          }, {
            before: 'Dudar',
            after: 'Ejecutar con método'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.35,
            delay: i * 0.08
          }} className="flex items-center gap-3 md:gap-4" data-id="element-21">
                <div className="flex items-center gap-2 flex-1 bg-gray-50 rounded-xl p-3 md:p-4 border border-gray-100" data-id="element-22">
                  <XIcon className="w-5 h-5 flex-shrink-0" style={{
                color: '#e76f51'
              }} data-id="element-23" />
                  <span className="text-base line-through" style={{
                color: '#5a5248'
              }} data-id="element-24">
                    {item.before}
                  </span>
                </div>
                <span className="text-lg font-bold" style={{
              color: '#e76f51'
            }} data-id="element-25">
                  →
                </span>
                <div className="flex items-center gap-2 flex-1 bg-white rounded-xl p-3 md:p-4 shadow-md border border-gray-100" data-id="element-26">
                  <CheckIcon className="w-5 h-5 flex-shrink-0" style={{
                color: '#07c86e'
              }} data-id="element-27" />
                  <span className="text-base font-bold" style={{
                color: '#1A1614'
              }} data-id="element-28">
                    {item.after}
                  </span>
                </div>
              </motion.div>)}
          </div>

          {/* Visualization quote — condensed */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5
        }} className="bg-[#F5EDE4] rounded-3xl p-8 md:p-10 text-center" data-id="element-29">
            <p className="text-lg md:text-xl italic mb-4" style={{
            color: '#5a5248',
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-30">
              Imagina cortar tu primer roll XL. Capas gruesas visibles. Altura
              firme. Glaseado perfecto.
            </p>
            <p className="text-xl md:text-2xl font-bold mb-1" style={{
            color: '#1A1614'
          }} data-id="element-31">
              No parece casero.
            </p>
            <p className="text-xl md:text-2xl font-bold" style={{
            color: '#e76f51'
          }} data-id="element-32">
              Parece vitrina de bakery profesional.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}